import React from "react";
import { useFlash } from "../../context/flashcontext";
import { useProfile } from "../../hooks/useProfile";
import ProfileView from "./ProfileViewModern";

function ProfileContainer() {
    const { showFlash } = useFlash();
    const profileHook = useProfile(showFlash);
    return <ProfileView {...profileHook} />;
}

export default ProfileContainer;
